import { render } from "./booking2.vue?vue&type=template&id=23b10fca"
import script from "./booking2.vue?vue&type=script&lang=js"
export * from "./booking2.vue?vue&type=script&lang=js"
script.render = render

export default script